export default "__VITE_ASSET__DyJImgH9__"